import { List, ListProps, styled } from "@mui/material";

const AppMenuList = styled(List)<ListProps>(({ theme }) => ({
    
}));

export default AppMenuList;
